import { styled } from '@mui/material';

const PageWrapper = ({ children, maxWidth = 'lg' }: Props) => {
  return <StyledMain $maxWidth={maxWidth}>{children}</StyledMain>;
};

export default PageWrapper;

interface Props {
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | false;
}

type MaxWidthKey = 'sm' | 'md' | 'lg' | false;

const StyledMain = styled('main', {
  shouldForwardProp: (prop) => prop !== '$maxWidth',
})<{ $maxWidth?: MaxWidthKey }>(({ theme, $maxWidth }) => ({
  width: '100%',
  maxWidth:
    $maxWidth && typeof $maxWidth === 'string'
      ? theme.breakpoints.values[$maxWidth]
      : undefined,
  margin: '0 auto',
  padding: theme.spacing(2, 3, 2, 3),
  boxSizing: 'border-box',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3, 4, 3, 4),
  },
}));
